import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Zap } from "lucide-react";
import { isStandalone } from "@/lib/pwa";

// Native-feeling launch splash — only shows when the app runs installed
// (standalone display-mode), so normal browser visitors never see it.
export function SplashScreen() {
  const [show, setShow] = useState(() => isStandalone());

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => setShow(false), 1400);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="pwa-splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[100] grid place-items-center"
          style={{ background: "linear-gradient(160deg, #4F46E5 0%, #7C3AED 55%, #0B1120 100%)" }}
        >
          <motion.div
            initial={{ scale: 0.6, opacity: 0, y: 12 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 16 }}
            className="flex flex-col items-center gap-4"
          >
            <span className="grid place-items-center h-20 w-20 rounded-3xl bg-white/15 backdrop-blur-md ring-1 ring-white/30 shadow-2xl">
              <Zap className="h-10 w-10 text-white fill-current" />
            </span>
            <span className="font-heading font-extrabold text-white text-2xl tracking-tight">AI Pathshaalaa</span>
            <span className="block h-1 w-16 rounded-full bg-white/30 overflow-hidden">
              <motion.span className="block h-full bg-white"
                initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: 1.2, ease: "easeInOut" }} />
            </span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
